import React, { useEffect } from "react"
import { Grid, Divider, Popup } from "semantic-ui-react"
import { withStyles } from "@material-ui/core/styles"
//New Icons
import { FiUser, FiSearch } from "react-icons/fi"
import { IoIosBasket } from "react-icons/io"
import Badge from "@material-ui/core/Badge"
import BarSearch from "../../Search/Search"
import Arrays from "../Arrays/Arrays"
import CurrencySelect from "../CurrencySelect/CurrencySelect"

import { Link } from "react-router-dom"
//redux
import { connect } from "react-redux"
import { getAllProducts } from "../../../../../redux/actions/products"

//styles
import "./styles.css"
const white = true
const transparent = false
const { Column } = Grid
const Nav = (props) => {
  const {
    auth,
    setIndex,
    opened,
    setOpened,
    handleLogout,
    visibleSearch,
    setVisibleSearch,
    nofications,
    categories,
    myLocation,
    getAllProducts,
    index,
  } = props

  useEffect(() => {
    getAllProducts()
  }, [getAllProducts])

  const handleTap = (index, search) => {
    setIndex(index)
    setVisibleSearch(search)
  }
  const handleSearch = () => {
    setVisibleSearch(!visibleSearch)
  }

  return (
    <nav className={"custom-navbar navbar-expand"}>
      <Grid
        columns={3}
        style={
          myLocation === "/"
            ? {
                boxShadow: white ? null : "inset 0 50px 70px",
                backgroundColor: myLocation === "/" ? "white" : "white",
                backgroundImage:
                  myLocation === "/"
                    ? transparent
                      ? "linear-gradient(to top, rgba(61, 61, 61, 0.4), black)"
                      : null
                    : null,
              }
            : null
        }
        centered
      >
        <Column
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            paddingLeft: "3%",
          }}
          width={3}
        >
          <CurrencySelect index={white ? false : myLocation === "/"} />
        </Column>
        <Column width={10} textAlign='center'>
          <div
            style={{
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Link to='/'>
              <img
                src={
                  myLocation === "/"
                    ? white
                      ? "/assets/logo.png"
                      : "/assets/logo-white.png"
                    : "/assets/logo.png"
                }
                alt='logo-foristeria'
                className='Logo'
              />
            </Link>
          </div>
          <ul
            className='navbar-nav'
            style={{
              paddingBottom: 10,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <li className='nav-item'>
              <Link to='/' onClick={() => handleTap(true, false)}>
                <p
                  /* className={`${"text-dark"} font-weight-bold`} */
                  className={`${
                    myLocation === "/" && !white ? "text-white" : "text-dark"
                  } font-weight-bold`}
                >
                  INICIO
                </p>
              </Link>
            </li>
            <li className='nav-item'>
              <Arrays
                index={myLocation === "/" && !white}
                setIndex={setIndex}
                categories={categories}
              />
            </li>
            <li className='nav-item'>
              <Link to='/gallery' onClick={() => handleTap(false, false)}>
                <p
                  /*  className={`${"text-dark"} font-weight-bold`} */
                  className={`${
                    myLocation === "/" && !white ? "text-white" : "text-dark"
                  } font-weight-bold`}
                >
                  NUESTROS CLIENTES
                </p>
              </Link>
            </li>

            <li className='nav-item'>
              <Link to='/blog' onClick={() => handleTap(false, false)}>
                <p
                  /* className={`${"text-dark"} font-weight-bold`} */
                  className={`${
                    myLocation === "/" && !white ? "text-white" : "text-dark"
                  } font-weight-bold`}
                >
                  BLOG
                </p>
              </Link>
            </li>
          </ul>
        </Column>
        <Column width={3}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
              height: "100%",
              paddingRight: "10%",
            }}
          >
            <div
              style={{
                paddingRight: 10,
              }}
            >
              {visibleSearch ? (
                <BarSearch
                  setVisibleSearch={setVisibleSearch}
                  products={props.products}
                  mylocation={myLocation}
                  className='InputNavBarSearch'
                />
              ) : myLocation === "/gallery" || myLocation === "/blog" ? null : (
                <button
                  type='button'
                  className='btn btn-link p-0 m-0'
                  style={{
                    position: "relative",
                  }}
                  onClick={() => handleSearch()}
                >
                  <FiSearch
                    size={25}
                    color={index && !white ? "white" : "black"}
                    className={
                      myLocation === "/gallery" || myLocation === "/blog"
                        ? "IconNavBarShoppingBlog"
                        : "IconNavBarShopping"
                    }
                  />
                </button>
              )}
            </div>
            <div
              style={{
                paddingRight: 10,
              }}
            >
              <Popup
                trigger={<FiUser size={25} />}
                position='bottom right'
                hoverable
              >
                <Grid columns={1}>
                  {auth.isEmpty ? (
                    <>
                      <Grid.Column textAlign='center'>
                        <Link to='/login' className='btn btn-outline-dark w-75'>
                          <p className='font-weight-bolder'>Ingresar</p>
                        </Link>
                      </Grid.Column>
                      <Grid.Column textAlign='center'>
                        <Link to='/signup' className='btn btn-dark w-75'>
                          <p className='font-weight-bolder'>Registrarse</p>
                        </Link>
                      </Grid.Column>
                    </>
                  ) : (
                    <>
                      <Grid.Column textAlign='center'>
                        <Link
                          to='/account'
                          className='btn btn-outline-dark w-75 '
                        >
                          <p className='font-weight-bolder'>Cuenta</p>
                        </Link>
                      </Grid.Column>
                      <Grid.Column textAlign='center'>
                        <Link
                          to='/'
                          className='btn btn-dark w-75 '
                          onClick={handleLogout}
                        >
                          <p className='font-weight-bolder'>Salir</p>
                        </Link>
                      </Grid.Column>
                    </>
                  )}
                </Grid>
              </Popup>
            </div>
            <div>
              <StyledBadge badgeContent={nofications} color='error'>
                <IoIosBasket
                  type='button'
                  onClick={() => setOpened(!opened)}
                  size={25}
                  color={myLocation === "/" && !white ? "white" : "black"}
                  className={
                    myLocation === "/gallery" || myLocation === "/blog"
                      ? "IconNavBarShoppingBlog"
                      : "IconNavBarShopping"
                  }
                />
              </StyledBadge>
            </div>
          </div>
        </Column>
      </Grid>

      <Divider fitted style={{ marginTop: 10 }} />
    </nav>
  )
}

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -3,
    top: 4,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
    margin: 2,
  },
}))(Badge)

const mapStateToProps = (state) => {
  return {
    products: state.products.products,
  }
}

export default connect(mapStateToProps, {
  getAllProducts,
})(Nav)
